import { useContext } from 'react';
import { AuthContext, type AuthState } from '@/auth/AuthContext';

export function useAuth(): AuthState {
  const value = useContext(AuthContext);
  if (!value) throw new Error('useAuth must be used inside <AuthProvider>');
  return value;
}
